module.exports = __webpack_public_path__ + "edb2caa71a734fd46caf5d1b74c5c311.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/pap_testimonial-1-author.jpg
// module id = 3071
// module chunks = 2